// Annahmen der Rechenhilfen (Stichtag, Kenntnis, Verstoß, Zahlungszeitpunkt, Hemmung, Vergleichswerte) –
// gemeinsam für Standortbericht und Auswertung. Alle Lesarten sind Schalter; der Standard ist die konservative Lesart.
import { KENNTNIS_TEXT, VERSTOSS_TEXT, ZAHLUNG_TEXT, type Annahmen } from '../daten/analyse.js';

interface Props {
  wert: Annahmen;
  onChange: (a: Annahmen) => void;
  /** Vergleichswerte anbieten (nur, wenn die Schätzung sichtbar ist) */
  mitVergleichswert: boolean;
}

const SZENARIEN = ['niedrig', 'mittel', 'hoch'] as const;

export function AnnahmenFormular({ wert, onChange, mitVergleichswert }: Props) {
  const setze = (teil: Partial<Annahmen>) => onChange({ ...wert, ...teil });
  const setzeVergleichswert = (i: number, v: string) => {
    const werte = [...wert.vergleichswerte] as Annahmen['vergleichswerte'];
    werte[i] = v;
    setze({ vergleichswerte: werte });
  };
  const hemmungUnvollstaendig = (wert.hemmungVon === '') !== (wert.hemmungBis === '') || (!!wert.hemmungVon && !!wert.hemmungBis && wert.hemmungBis <= wert.hemmungVon);
  return (
    <fieldset className="annahmen">
      <legend>Annahmen der Rechenhilfe</legend>
      <div className="filterzeile">
        <label className="feld">
          <span className="feld-label">Stichtag</span>
          <input type="date" value={wert.stichtag} onChange={(e) => setze({ stichtag: e.target.value })} />
        </label>
        <label className="feld">
          <span className="feld-label">Kenntnis vom Anspruch</span>
          <select value={wert.kenntnis} onChange={(e) => setze({ kenntnis: e.target.value as Annahmen['kenntnis'] })}>
            {(Object.keys(KENNTNIS_TEXT) as Array<keyof typeof KENNTNIS_TEXT>).map((k) => (
              <option key={k} value={k}>
                {KENNTNIS_TEXT[k]}
              </option>
            ))}
          </select>
        </label>
        {wert.kenntnis === 'datum' && (
          <label className="feld">
            <span className="feld-label">Datum der Kenntnis</span>
            <input type="date" value={wert.kenntnisDatum} onChange={(e) => setze({ kenntnisDatum: e.target.value })} required />
          </label>
        )}
        <label className="feld">
          <span className="feld-label">Verstoß</span>
          <select value={wert.verstoss} onChange={(e) => setze({ verstoss: e.target.value as Annahmen['verstoss'] })}>
            {(Object.keys(VERSTOSS_TEXT) as Array<keyof typeof VERSTOSS_TEXT>).map((k) => (
              <option key={k} value={k}>
                {VERSTOSS_TEXT[k]}
              </option>
            ))}
          </select>
        </label>
        {wert.verstoss === 'dauer' && (
          <label className="feld">
            <span className="feld-label">Beendigung (leer = noch nicht beendet)</span>
            <input type="date" value={wert.beendigung} onChange={(e) => setze({ beendigung: e.target.value })} />
          </label>
        )}
        <label className="feld">
          <span className="feld-label">Zahlung</span>
          <select value={wert.zahlung} onChange={(e) => setze({ zahlung: e.target.value as Annahmen['zahlung'] })}>
            {(Object.keys(ZAHLUNG_TEXT) as Array<keyof typeof ZAHLUNG_TEXT>).map((k) => (
              <option key={k} value={k}>
                {ZAHLUNG_TEXT[k]}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="filterzeile">
        <label className="feld">
          <span className="feld-label">Hemmung von (§ 209 BGB, optional)</span>
          <input type="date" value={wert.hemmungVon} onChange={(e) => setze({ hemmungVon: e.target.value })} aria-invalid={hemmungUnvollstaendig} />
        </label>
        <label className="feld">
          <span className="feld-label">Hemmung bis</span>
          <input type="date" value={wert.hemmungBis} onChange={(e) => setze({ hemmungBis: e.target.value })} aria-invalid={hemmungUnvollstaendig} />
        </label>
        {mitVergleichswert &&
          SZENARIEN.map((name, i) => (
            <label className="feld" key={name}>
              <span className="feld-label">Vergleichswert {name} (€ netto je Monat)</span>
              <input type="text" inputMode="decimal" value={wert.vergleichswerte[i]} placeholder={i === 1 ? 'z. B. 80,00' : ''} onChange={(e) => setzeVergleichswert(i, e.target.value)} />
            </label>
          ))}
      </div>
      {hemmungUnvollstaendig && <p className="zelle-hinweis">Hemmung: bitte Beginn und Ende angeben (Ende nach Beginn) – sonst bleibt sie unberücksichtigt.</p>}
    </fieldset>
  );
}
